// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { EnumFilter } from './EnumFilter';
import { filterIsTrue, filterIsFalse } from '../../messages'; // tslint:enable:max-line-length

var BooleanFilter = {
  name: 'KendoBooleanFilter',
  props: {
    filter: {
      type: Object,
      required: true
    },
    dataItems: {
      type: Array,
      default: function _default() {
        return undefined;
      }
    },
    defaultItem: Object
  },
  data: function data() {
    return {
      currentData: [{
        text: filterIsTrue,
        value: true
      }, {
        text: filterIsFalse,
        value: false
      }]
    };
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    return (// @ts-ignore
      h(EnumFilter, {
        filter: this.$props.filter,
        attrs: this.v3 ? undefined : {
          filter: this.$props.filter,
          dataItems: this.$props.dataItems || this.currentData,
          defaultItem: this.$props.defaultItem
        },
        onFilterchange: this.handleFilterChange,
        on: this.v3 ? undefined : {
          "filterchange": this.handleFilterChange
        },
        dataItems: this.$props.dataItems || this.currentData,
        defaultItem: this.$props.defaultItem
      })
    );
  },
  methods: {
    handleFilterChange: function handleFilterChange(event) {
      this.$emit('filterchange', event);
    }
  }
};
var BooleanFilterVue3 = BooleanFilter;
export { BooleanFilter, BooleanFilterVue3 };